<template>
    <div class="container">
        <div class="py-5 text-center">
            <h2>Изменение</h2>
        </div>

        <div v-if="errors" v-for="error in errors">
            <div class="alert alert-danger" role="alert">{{ error}}</div>
        </div>

        <div class="row">

            <div class="col-md">
                <form class="needs-validation" @submit="onSubmit">
                    <div class="mb-3">
                        <label for="username">Email</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">@</span>
                            </div>
                            <input type="text" class="form-control" id="username" placeholder="Email"
                                   v-model="item.email" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="password">Пароль</label>
                            <input type="password" class="form-control" id="password" v-model="item.password" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="password-check">Повторите пароль</label>
                            <input type="password" class="form-control" id="password-check"
                                   v-model="item.password_confirmation" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                    </div>


                    <hr class="mb-4">
                    <button class="btn btn-primary btn-lg btn-block btn-yellow" type="submit">Изменить</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    const swal = require('sweetalert2');
    export default {
        data() {
            return {
                item: {},
                token: this.$route.query.token,
                errors: []
            }
        },

        methods: {
            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];
                if (!this.item.email) this.errors.push("Email обязателен.");
                if (!this.item.password) this.errors.push("Пароль обязателен.");
                if (this.item.password && this.item.password.length <= 5) this.errors.push("Минимальная длина пароля 6 символов.");
                if (!/\d/.test(this.item.password)) this.errors.push("Содержать минимум одну цифру.");
                if (!/[A-Z]/.test(this.item.password)) this.errors.push("Содержать минимум 1 заглавную букву.");
                if (this.item.password !== this.item.password_confirmation) this.errors.push("Пароли не совпадают.");
            },

            onSubmit(e) {
                this.checkForm(e)
                if (this.errors.length === 0) {
                    let formData = new FormData();
                    formData.append('email', this.item.email);
                    formData.append('token', this.token);
                    formData.append('password', this.item.password);
                    formData.append('password_confirmation', this.item.password_confirmation);

                    this.axios
                        .post(this.axios.defaults.baseURL + 'password/reset', formData)
                        .then(response => {
                            console.log(response.data)
                            if (response) {
                                swal.fire({
                                    icon: 'success',
                                    title: 'Ваш пароль успешно изменен',
                                    showConfirmButton: true,
                                });
                                this.$router.push({name: "login"})
                            }
                        })
                        .catch(error => {
                            this.errors.push("Email не совпадает или время действия ссылки истекло.")
                        })
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .container {
        max-width: 768px !important;
        margin: 0 auto 50px;
    }

    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }

    .btn-yellow {
        background-color: #e8d800;
        color: #000;
        box-shadow: none !important;
        border: 0;
    }

    .btn-yellow:hover {
        background-color: #000;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/auth/reset-password.vue